/* ============================================================
   CORN GLUTEN PDP — JavaScript
   product.corn-gluten template
   Handles: bundles, ATC (cart drawer), gallery, calculator,
   smooth scroll, sticky bar, scroll reveal
   ============================================================ */
(function() {
  'use strict';

  /* ---- helpers ---- */
  function fmt(cents, moneyFmt) {
    var dollars = (cents / 100).toFixed(2);
    if (moneyFmt && moneyFmt.indexOf('amount') > -1) {
      return moneyFmt.replace(/\{\{\s*amount\s*\}\}/, dollars).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    return '$' + dollars;
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }


  /* ============================================================
     BUNDLE SELECTOR
     ============================================================ */
  function initBundles() {
    var hero = qs('.cgl-hero');
    if (!hero) return;

    var unitPrice = parseInt(hero.getAttribute('data-cgl-product-price'), 10);
    var moneyFmt = hero.getAttribute('data-cgl-money-format');
    var cards = qsa('[data-cgl-bundle]', hero);
    var qtyInput = qs('[data-cgl-qty-input]', hero);
    var atcPrice = qs('[data-cgl-atc-price]', hero);
    var minusBtn = qs('[data-cgl-qty-minus]', hero);
    var plusBtn = qs('[data-cgl-qty-plus]', hero);

    // Discount tiers
    var discountTiers = [
      { min: 6, pct: 15 },
      { min: 3, pct: 10 },
      { min: 2, pct: 5 }
    ];

    function getDiscount(bags) {
      for (var i = 0; i < discountTiers.length; i++) {
        if (bags >= discountTiers[i].min) return discountTiers[i].pct;
      }
      return 0;
    }

    function updatePrice() {
      var bags = parseInt(qtyInput.value, 10) || 1;
      if (bags < 1) { bags = 1; qtyInput.value = 1; }
      var disc = getDiscount(bags);
      var total = Math.round(unitPrice * bags * (1 - disc / 100));
      if (atcPrice) atcPrice.textContent = fmt(total, moneyFmt);

      // Sync bundle card highlight to match qty (if exact match exists)
      cards.forEach(function(c) { c.classList.remove('cgl-hero__bundle-card--active'); });
      var match = qs('[data-cgl-bundle="' + bags + '"]', hero);
      if (match) match.classList.add('cgl-hero__bundle-card--active');
    }

    // Pre-calculate and display bundle card prices with strikethrough
    cards.forEach(function(card) {
      var bags = parseInt(card.getAttribute('data-cgl-bundle'), 10);
      var disc = getDiscount(bags);
      var fullPrice = unitPrice * bags;
      var total = Math.round(fullPrice * (1 - disc / 100));
      var priceEl = qs('[data-cgl-bundle-display-price]', card);
      var compareEl = qs('[data-cgl-bundle-compare-price]', card);
      if (priceEl) priceEl.textContent = fmt(total, moneyFmt);
      if (compareEl && disc > 0) compareEl.textContent = fmt(fullPrice, moneyFmt);
    });

    // Bundle card clicks set the qty input
    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        var bags = parseInt(card.getAttribute('data-cgl-bundle'), 10);
        if (qtyInput) qtyInput.value = bags;
        updatePrice();
      });
    });

    // +/- buttons
    if (minusBtn) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) { qtyInput.value = val - 1; updatePrice(); }
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
        updatePrice();
      });
    }

    // Manual input change
    if (qtyInput) {
      qtyInput.addEventListener('change', updatePrice);
      qtyInput.addEventListener('input', updatePrice);
    }

    // Initial price display
    updatePrice();
  }




  /* ============================================================
     CALCULATOR ATC — syncs quantity to hidden form input.
     The <product-form> custom element handles the actual ATC.
     ============================================================ */
  function initCalcATC() {
    // Not needed — the calculator's calculate() function already updates
    // data-cgl-calc-atc-bags. We just need to sync the hidden qty input
    // before the product-form submits.
    var calcForm = qs('[data-cgl-calc-form]');
    if (!calcForm) return;

    calcForm.addEventListener('submit', function() {
      var bags = parseInt(qs('[data-cgl-calc-atc-bags]').textContent, 10) || 1;
      var qtyInput = qs('[data-cgl-calc-qty-input]');
      if (qtyInput) qtyInput.value = bags;
    });
  }


  /* Gallery is handled by the theme's product-gallery-enhanced snippet */


  /* ============================================================
     COVERAGE CALCULATOR
     ============================================================ */
  function initCalculator() {
    var widget = qs('[data-cgl-calc]');
    if (!widget) return;

    var input = qs('[data-cgl-calc-input]', widget);
    var results = qs('[data-cgl-calc-results]', widget);
    var unitBtns = qsa('[data-cgl-calc-unit]', widget);
    var pricePerBag = parseInt(widget.getAttribute('data-cgl-calc-price'), 10);
    var moneyFmt = widget.getAttribute('data-cgl-calc-money-format');
    var currentUnit = 'm2';

    var discountTiers = [
      { min: 6, pct: 15 },
      { min: 3, pct: 10 },
      { min: 2, pct: 5 }
    ];

    function getDiscount(bags) {
      for (var i = 0; i < discountTiers.length; i++) {
        if (bags >= discountTiers[i].min) return discountTiers[i].pct;
      }
      return 0;
    }

    function calculate() {
      var val = parseFloat(input.value);
      if (!val || val <= 0) { results.style.display = 'none'; return; }

      var areaM2 = currentUnit === 'sqft' ? val * 0.0929 : val;
      var kgNeeded = Math.ceil(areaM2 * 0.1); // 10 kg per 100 m²
      var bags = Math.ceil(kgNeeded / 25);
      if (bags < 1) bags = 1;

      var discount = getDiscount(bags);
      var fullPrice = pricePerBag * bags;
      var savings = Math.round(fullPrice * discount / 100);
      var totalPrice = fullPrice - savings;

      qs('[data-cgl-calc-kg]', widget).textContent = (bags * 25) + ' kg';
      qs('[data-cgl-calc-bags]', widget).textContent = bags + (bags > 1 ? ' sacs' : ' sac');
      qs('[data-cgl-calc-price-full]', widget).textContent = fmt(fullPrice, moneyFmt);

      var savingsRow = qs('[data-cgl-calc-savings-row]', widget);
      if (discount > 0) {
        savingsRow.style.display = 'flex';
        qs('[data-cgl-calc-discount-pct]', widget).textContent = discount;
        qs('[data-cgl-calc-savings]', widget).textContent = '-' + fmt(savings, moneyFmt);
      } else {
        savingsRow.style.display = 'none';
      }

      qs('[data-cgl-calc-total]', widget).textContent = fmt(totalPrice, moneyFmt);
      qs('[data-cgl-calc-atc-bags]', widget).textContent = bags;

      // Upsell tip
      var tip = qs('[data-cgl-calc-tip]', widget);
      if (bags === 1) {
        tip.textContent = 'Un deuxième sac vous donne assez pour deux applications par saison et vous économisez 5%.';
        tip.style.display = 'block';
      } else if (bags === 2) {
        tip.textContent = 'Avec 3 sacs, vous passez à 10% de rabais au lieu de 5%.';
        tip.style.display = 'block';
      } else if (bags >= 3 && bags < 6) {
        tip.textContent = 'À 6 sacs, vous obtenez 15% de rabais. Partagez avec un voisin!';
        tip.style.display = 'block';
      } else {
        tip.style.display = 'none';
      }

      results.style.display = 'block';
    }

    input.addEventListener('input', calculate);

    unitBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        unitBtns.forEach(function(b) { b.classList.remove('cgl-calc__unit-btn--active'); });
        btn.classList.add('cgl-calc__unit-btn--active');
        currentUnit = btn.getAttribute('data-cgl-calc-unit');
        calculate();
      });
    });
  }


  /* ============================================================
     SCROLL REVEAL
     ============================================================ */
  function initReveal() {
    var els = qsa('.cgl-reveal, .cgl-reveal-stagger');
    if (!els.length) return;

    // Hero visible immediately
    var hero = qs('.cgl-hero');
    if (hero) hero.classList.add('is-visible');

    // Proof bar visible immediately (no delay needed)
    var proofbar = qs('.cgl-proofbar');
    if (proofbar) proofbar.classList.add('is-visible');

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });

    els.forEach(function(el) { observer.observe(el); });
  }


  /* ============================================================
     SMOOTH SCROLL — handles all [data-cgl-scroll] links
     Uses event delegation so dynamically rendered links also work
     ============================================================ */
  function initSmoothScroll() {
    // Use capture phase so we intercept before native anchor navigation
    document.addEventListener('click', function(e) {
      var link = e.target.closest('[data-cgl-scroll]');
      if (!link) return;

      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      e.preventDefault();
      e.stopPropagation();

      // Try direct ID match first
      var target = document.getElementById(href.substring(1));

      // Fallback: find section whose Shopify wrapper ID ends with the hash
      if (!target) {
        target = document.querySelector('[id$="' + href.substring(1) + '"]');
      }

      if (target) {
        var headerOffset = 80; // account for sticky header
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }, true); // capture: true — intercept before browser default
  }




  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    initBundles();
    initCalculator();
    initCalcATC();
    initReveal();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
